import { render, staticRenderFns } from "./AddElement.vue?vue&type=template&id=2757e199"
import script from "./AddElement.vue?vue&type=script&lang=js"
export * from "./AddElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports